export default __webpack_public_path__ + "static/media/card2.ff5675f8.jpg";